const noticeTypes = [
  {
    name: 'Push уведомления',
    id: 1,
    typeName: 'PUSH',
  },
  {
    name: 'E-mail рассылка',
    id: 2,
    typeName: 'EMAIL',
	},
	{
    name: 'SMS рассылка',
    id: 3,
    typeName: 'SMS',
  },
  {
    name: 'Обзвон',
    id: 4,
    typeName: 'PHONE',
  },
];

export default noticeTypes;
